import React, { useState } from 'react';
import {
    TextField as Input,
    IconButton,
    InputAdornment,
} from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';

import { useStyles } from './appSearchField.styles';

function AppSearchField({ onSearch }) {
    const classes = useStyles();
    const [searchValue, setSearchValue] = useState('');

    function handleKeyDown (e) {
        if (e.key === 'Enter') {
            onSearch(searchValue);
        }
    };

    function handleChange (e) {
        const v = e.target.value;
        setSearchValue(v);
        clearTimeout(window.searchTO);
        window.searchTO = setTimeout(() => {
            onSearch(v);
        }, 400);
    }

    return (
        <Input
            id="appSearchField"
            className={classes.searchField}
            onKeyDown={handleKeyDown}
            onChange={handleChange}
            InputProps={{
                disableUnderline: true,
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="Search integrations by name"
                            onClick={() => onSearch(searchValue)}
                        >
                            <SearchIcon />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            value={searchValue}
            margin="normal"
            placeholder="Search integrations..."
        />
    );
}

export default AppSearchField;
